import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import SettingStyles from '../../../SettingStyle.module.scss';
import { PATH as STAFFS_PATH } from '~/pages/settings/staffs';
import { FormInputPage } from '../FormInputPage';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <div className={SettingStyles.BreadcrumbsBlock}>
        <Breadcrumbs
          items={[
            { label: '担当者一覧', as: Link, href: STAFFS_PATH },
            { label: '担当者追加' }
          ]}
        />
      </div>
      <h2 className={SettingStyles.SettingTitle}>担当者追加</h2>
      <FormInputPage />
    </ClientSettingLayout>
  </DefaultV2>
);
